import { defineComponent as _defineComponent } from 'vue'
import CarouselCard from './CarouselCard.vue';
import { computed } from 'vue';
import { ITaxonomyViewModel } from 'JS/types/Taxonomy';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryLinkCard',
  props: {
    category: null
  },
  setup(__props: any) {

const props = __props as {
	category: ITaxonomyViewModel
}



const imageUrls = computed(() => {
	return {
		imageUrl: props.category.imageUrl,
		imageUrlWebP: props.category.imageUrlWebP
	};
});

return { __sfc: true,props, imageUrls, CarouselCard }
}

})